export default (origin: 'MOBILE' | 'DESKTOP') => {
  if (typeof window !== 'undefined' && window.location.origin) {
    if (origin === 'MOBILE') return `https://m.comparacar.com.br${window.location.pathname}${window.location.search}`
    if (origin === 'DESKTOP') return `https://comparacar.com.br${window.location.pathname}${window.location.search}`
  }
  return ''
}
